export default "__VITE_ASSET__v_u$lL94__"